/* The header's scroll edge.

   Which element scrolls depends on the template: the standalone homepage scrolls inside
   .page-wrapper, while a policy or a page template scrolls the document. Picking one and
   trusting it left the header flat on half the site, so this watches both and takes
   whichever has actually moved.

   Passive listeners, one attribute toggle, nothing measured per frame, and the work is
   coalesced into an animation frame so a fast scroll cannot queue up layout reads. */
(() => {
  const body = document.body;
  if (!body || body.dataset.covaScrollEdge) return;
  body.dataset.covaScrollEdge = 'true';

  const wrapper = document.querySelector('.page-wrapper');
  const readTop = () => {
    const documentTop = window.scrollY || document.documentElement.scrollTop || 0;
    const wrapperTop = wrapper ? wrapper.scrollTop : 0;
    return Math.max(documentTop, wrapperTop);
  };

  let queued = false;
  const sync = () => {
    queued = false;
    if (readTop() > 8) body.setAttribute('data-cova-scrolled', '');
    else body.removeAttribute('data-cova-scrolled');
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  if (wrapper) wrapper.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', sync);
  sync();
})();
